import { render, staticRenderFns } from "./shifting.vue?vue&type=template&id=39810797&scoped=true&"
import script from "./shifting.vue?vue&type=script&lang=js&"
export * from "./shifting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39810797",
  null
  
)

export default component.exports